import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaFechamentoFinanceiroModel } from "../models/fechamentoFinanceiro/buscaFechamentoFinanceiroModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarFechamentoFinanceiro, setModalDeletarFechamentoFinanceiro } from "../redux/slices/fechamentoFinanceiro/fechamentoFinanceiroSlice";

export const buscarFechamentoFinanceiro = createAsyncThunk("/FechamentoFinanceiro/BuscarFechamentoFinanceiro", async (args: BuscaFechamentoFinanceiroModel) => {
  try {
    const data = await api.get("/FechamentoFinanceiro/BuscarFechamentoFinanceiro/", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarFechamentoFinanceiro = createAsyncThunk("/FechamentoFinanceiro/AtualizarFechamentoFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/FechamentoFinanceiro/AtualizarFechamentoFinanceiro/", payload.value);
    toastSucess("Fechamento financeiro atualizado com sucesso");
    dispatch(setModalCadastrarFechamentoFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarFechamentoFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarFechamentoFinanceiro = createAsyncThunk("/FechamentoFinanceiro/DeletarFechamentoFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/FechamentoFinanceiro/DeletarFechamentoFinanceiro/?id=" + payload.value);
    toastSucess("Fechamento financeiro removido com sucesso");
    dispatch(setModalDeletarFechamentoFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarFechamentoFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
